import {
  PlatformType
} from '@invideoio/web-shared/constants/common';
import { LOCAL_STORAGE } from '@invideoio/web-shared/utils/utils.constant';

export const isUserLoggedIn = () => {
  const authToken = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN);
  return (
    authToken != null && authToken !== undefined && authToken?.trim() !== ''
  );
};

export const getYoutubeEmbedLink = (url: string) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : '';
};

export const getYoutubePreviewUrl = (
  ytVideoId: string,
  platform: PlatformType,
) => {
  let qualityPath = 'hqdefault';
  switch (platform) {
    case PlatformType.Desktop:
      qualityPath = 'maxresdefault';
      break;
    default:
      qualityPath = 'hqdefault';
      break;
  }
  return `https://img.youtube.com/vi/${ytVideoId}/${qualityPath}.jpg`;
};

export const filterBlogResponseForCards = (response: Record<string, any>[]) => {
  return response.map(blog => {
    return {
      id: blog.id,
      Slug: blog.Slug,
      Title: blog.Title,
      published_at: blog.published_at,
      platform: blog.platform,
      profession: blog.profession,
      trending: blog.trending,
      categories_v_2: blog.categories_v_2,
      FeatureImage: blog.FeatureImage,
    };
  });
};
